var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08278 15.7005C1.86097 16.1441 2.18355 16.666 2.67952 16.666H5.98766C6.24037 16.666 6.47139 16.5232 6.5844 16.2972L9.52956 10.4069C9.57589 10.3142 9.6 10.2121 9.6 10.1085V1.33319C9.6 0.964721 9.3013 0.666016 8.93282 0.666016H0.667178C0.298706 0.666016 0 0.964721 0 1.33319V9.59884C0 9.96731 0.298706 10.266 0.667178 10.266H3.72048C4.21645 10.266 4.53903 10.788 4.31723 11.2316L2.08278 15.7005ZM14.8828 15.7005C14.661 16.1441 14.9836 16.666 15.4795 16.666H18.7877C19.0404 16.666 19.2714 16.5232 19.3844 16.2972L22.3296 10.4069C22.3759 10.3142 22.4 10.2121 22.4 10.1085V1.33319C22.4 0.964721 22.1013 0.666016 21.7328 0.666016H13.4672C13.0987 0.666016 12.8 0.964721 12.8 1.33319V9.59884C12.8 9.96731 13.0987 10.266 13.4672 10.266H16.5205C17.0165 10.266 17.339 10.788 17.1172 11.2316L14.8828 15.7005Z",
    fill: "#1E42D3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.03cf1364.svg";
export { ForwardRef as ReactComponent };